var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackWidth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5999 9.99553L11.3999 11.7955L15.5999 7.59553M11.6869 16.9868L6.67816 21.9955V16.9868H4.7999C3.47442 16.9868 2.3999 15.9123 2.3999 14.5868V5.19553C2.3999 3.87005 3.47442 2.79553 4.7999 2.79553H19.1999C20.5254 2.79553 21.5999 3.87005 21.5999 5.19553V14.5868C21.5999 15.9123 20.5254 16.9868 19.1999 16.9868H11.6869Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackWidth2);
export default __webpack_public_path__ + "static/media/feedback-width-2.952549efc9794fc750f40bc7f397471d.svg";
export { ForwardRef as ReactComponent };